import React from 'react';

const logos = [
  { name: 'Google',    src: 'https://cdn.simpleicons.org/google' },
  { name: 'Apple',     src: 'https://cdn.simpleicons.org/apple/000' },
  { name: 'Microsoft', src: 'https://cdn.simpleicons.org/microsoft' },
  { name: 'Meta',      src: 'https://cdn.simpleicons.org/meta' },
  { name: 'Amazon',    src: 'https://cdn.simpleicons.org/amazon/000' },
  { name: 'Netflix',   src: 'https://cdn.simpleicons.org/netflix' },
  { name: 'Spotify',   src: 'https://cdn.simpleicons.org/spotify' },
  { name: 'Tesla',     src: 'https://cdn.simpleicons.org/tesla/000' },
  { name: 'Nvidia',    src: 'https://cdn.simpleicons.org/nvidia' },
  { name: 'OpenAI',    src: 'https://cdn.simpleicons.org/openai/000' },
  { name: 'Adobe',     src: 'https://cdn.simpleicons.org/adobe' },
  { name: 'Intel',     src: 'https://cdn.simpleicons.org/intel' },
];

const LogoMarquee = () => {
  const loop = [...logos, ...logos];

  return (
    <section
      aria-label="Featured providers"
      className="relative py-12"
      style={{
        backgroundColor: '#fff',
        borderTop: '1px solid rgba(0,0,0,0.04)',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p
          className="text-center uppercase tracking-widest mb-8"
          style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: '12px',
            fontWeight: 600,
            color: 'var(--gray-10)',
            letterSpacing: '0.18em',
          }}
        >
          Our Featured Providers
        </p>

        <div className="logo-marquee">
          <div className="logo-marquee__track">
            {loop.map((logo, i) => (
              <div className="logo-marquee__item" key={`${logo.name}-${i}`}>
                <img
                  src={logo.src}
                  alt={logo.name}
                  loading="lazy"
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .logo-marquee {
          position: relative;
          overflow: hidden;
          mask-image: linear-gradient(
            to right,
            transparent 0,
            #000 96px,
            #000 calc(100% - 96px),
            transparent 100%
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent 0,
            #000 96px,
            #000 calc(100% - 96px),
            transparent 100%
          );
        }
        .logo-marquee__track {
          display: flex;
          width: max-content;
          gap: 64px;
          padding: 8px 0;
          animation: logo-marquee-scroll 42s linear infinite;
        }
        .logo-marquee:hover .logo-marquee__track {
          animation-play-state: paused;
        }
        .logo-marquee__item {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          min-width: 96px;
        }
        .logo-marquee__item img {
          max-height: 36px;
          max-width: 140px;
          width: auto;
          height: auto;
          object-fit: contain;
          filter: grayscale(1);
          opacity: 0.55;
          transition: filter 220ms ease, opacity 220ms ease, transform 220ms ease;
          user-select: none;
        }
        .logo-marquee__item:hover img {
          filter: grayscale(0);
          opacity: 1;
          transform: scale(1.08);
        }
        @keyframes logo-marquee-scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .logo-marquee__track { animation: none; }
        }
      `}</style>
    </section>
  );
};

export default LogoMarquee;
